import { Box, IconButton, Link, Typography } from "@mui/material";
import React from "react";
import { useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Infos = ({ hideInfos }) => {
    const isMobile = useMediaQuery('(max-width:800px)');

    return (
        <Box
            sx={{
                // Sur mobile, on fixe la hauteur à 100vh pour permettre le scroll.
                height: isMobile ? "100dvh": "100vh",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box sx={{
                flex: 1,
                // Autorise le scroll en mobile si le contenu dépasse
                overflowY: "auto",
                paddingTop: isMobile ? "5vh" : "2vh",
                paddingRight: isMobile ? "10vw" : "100px",
                paddingLeft: isMobile ? "8vw" : "2vw",
                // Votre styling supplémentaire...
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
            }}>
                <Box>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between"
                    }}>
                        <Box
                            component="img"
                            sx={{
                                width: isMobile ? "auto" : "300px", // Adjust the size of the GIF
                                height: isMobile ? "60px" : "100px",
                                paddingBottom: isMobile ? "20px" : "0",
                                paddingTop: "20px"
                            }}
                            alt="Logo GIF"
                            src={isMobile ? `${process.env.PUBLIC_URL}/runner.gif` : `${process.env.PUBLIC_URL}/TTG_STUDIO_BLANC.svg`} // Path to your GIF
                        />
                        <IconButton
                            onClick={hideInfos}
                            sx={{
                                color: "white",
                                paddingRight: "5vw"
                            }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }}>Fondé en 2023,</Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"

                    }} >
                        tothego est un studio créatif multidisciplinaire
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"

                    }} >
                        qui réunit des professionnels passionnés
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"

                    }} >
                        qui travaillent ensemble de manière
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"

                    }} >
                        complémentaire pour réaliser vos projets.
                    </Typography>
                    <br />
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"

                    }} >
                        Nous avons allié nos forces
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"

                    }} >
                        et nos passés respectifs dans la création
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"

                    }} >

                        et la publicité pour vous accompagner
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"

                    }} >
                        du développement à la livraison.
                    </Typography>
                    <br />
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "#0E101F",
                        display: "inline", // Limite le fond à la taille du texte

                        backgroundColor: "white"
                    }} >
                        STUDIO
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Direction Artistique
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Photographie
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Réalisation Vidéo
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"

                    }} >
                        Graphisme
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Post Production
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Conseil / Expertise
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Production
                    </Typography>
                    <br />
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "#0E101F",
                        backgroundColor: "white",
                        display: "inline", // Limite le fond à la taille du texte

                    }} >
                        MUSIQUE
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Composition
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Création Sonore
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Mixage
                    </Typography>
                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white"
                    }} >
                        Voix Off
                    </Typography>

                    <Typography fontFamily={"Roboto"} sx={{
                        color: "white",
                    }} >
                        Enregistrement d’Artistes
                    </Typography>
                    <br />

                </Box>
                <br />
                <br />

                <Box sx={{
                    alignSelf: "flex-start",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px", // Espace entre chaque élément
                    marginBottom: isMobile ? "7vh" : "50px" // Un peu d'espace en bas
                }}>
                    <Link sx={{ color: "white", textDecoration: "underline" }} target="_blank" href="https://www.instagram.com/tothego_studio/">INSTAGRAM</Link>
                    <Link sx={{ color: "white", textDecoration: "underline" }} target="_blank" href="https://www.linkedin.com/company/tothego-studio">LINKEDIN</Link>
                    <Link sx={{ color: "white", textDecoration: "none" }} target="_blank" href="mailto:contact@tothegostudio.com">contact@tothegostudio.com</Link>
                </Box>

            </Box>
        </Box>

    );
}

export default Infos;
